// Pinia store for the app-wide image lightbox.
//
// Click any inline image (chat artifacts, published charts, attached
// images) to view it full-size in a centered modal with a download
// affordance. Usage:
//
//     import { useLightboxStore } from '@/stores/lightbox';
//     const lightbox = useLightboxStore();
//     lightbox.open({ src: url, alt: name, downloadUrl: url, filename: name });
//
// One <Lightbox/> mounted in AppShell renders the active image.

import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface LightboxImage {
  src:          string;
  alt?:         string;
  /** Same-origin URL used by the download button; defaults to `src`. */
  downloadUrl?: string;
  /** Suggested filename for the download. */
  filename?:    string;
}

export const useLightboxStore = defineStore('lightbox', () => {
  const active = ref<LightboxImage | null>(null);

  function open(img: LightboxImage): void { active.value = img; }
  function close(): void { active.value = null; }

  return { active, open, close };
});
